import { QueryReturnValue } from "@reduxjs/toolkit/dist/query/baseQueryTypes";
import {
    FetchBaseQueryError,
    FetchBaseQueryMeta,
} from "@reduxjs/toolkit/query";

type Callback = (...args: any[]) => any;
export function parseResponse(
    res: QueryReturnValue<unknown, FetchBaseQueryError, FetchBaseQueryMeta>,
    onData: Callback,
    onError: Callback
):
    | {
          data: string;
          error?: undefined;
      }
    | {
          error: {
              error: string;
              status: "CUSTOM_ERROR";
          };
          data?: undefined;
      } {
    if ("data" in res) {
        onData(res.data);
        return { data: "ready" };
    } else if ("error" in res) {
        onError(res.error);
        if (res.error && typeof res.error === "object" && "data" in res.error) {
            return {
                error: {
                    error: res.error.data as string,
                    status: `CUSTOM_ERROR`,
                },
            };
        } else {
            return {
                error: {
                    error: "UNKNOWN_ERROR",
                    status: `CUSTOM_ERROR`,
                },
            };
        }
    } else {
        onError(`UNKNOWN ERROR`);
        return {
            error: {
                error: `UNKNOWN ERROR`,
                status: `CUSTOM_ERROR`,
            },
        };
    }
}
